import { type BTFileSystem } from "legacyComponents/FileUploadContainer.types";

import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTIconExternalLink } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";
import { getOpenInNewTabLink } from "commonComponents/entity/media/common/MediaContextMenu/MediaContextMenu.utility";

interface IMenuItemOpenInNewTabProps {
    file: BTFileSystem;
}

const MenuItemOpenInNewTab = ({ file, ...antProps }: IMenuItemOpenInNewTabProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`openInNewTab-menuitem-${file.id}`}
            testid={`openInNewTab-menuitem-${file.id}`}
        >
            <BTExternalLink
                href={getOpenInNewTabLink(file)}
                isUnderline={false}
                key={`openInNewTab-${file.id}`}
                data-testid={`openInNewTab-${file.id}`}
            >
                <BTIconExternalLink /> Open in new tab
            </BTExternalLink>
        </BTMenu.Item>
    );
};

export default MenuItemOpenInNewTab;
